import Logo from "../components/Logo.jsx";
import Navigation from "../components/Navigation";

const Header = () => {
  return (
    <header>
      <Logo />
      <Navigation />
    </header>
  );
};

export default Header;
